export default "__VITE_ASSET__1bc56d7d__"